import { nk } from "../config/n-k";


export const nkIdsConsult = () => {
  return nk.nkConsult().then(response => response)
};

export const nkGenerator = (data) => {
  return nk.nkGenerator(data).then(response => response)
}
